import dayjs from 'dayjs';
import getSummarySales from './getSummarySales';

const DATE_FORMAT = 'YYYY-MM-DD';

export default function getDailySalesData(
  or = [],
  d1 = [],
  d2 = [],
  d3 = [],
  period = [],
) {
  if (!or.length && !d1.length && !d2.length && !d3.length) return [];

  // 선택한 조회 기간의 종료일부터 시작일까지 양 끝 날짜를 모두 생성합니다.
  const startDate = dayjs(period[0]).startOf('day');
  const endDate = dayjs(period[1]).startOf('day');
  const diff = endDate.diff(startDate, 'day');

  if (!startDate.isValid() || !endDate.isValid() || diff < 0) return [];

  const days = new Array(diff + 1)
    .fill(null)
    .map((_, index) => endDate.subtract(index, 'day').format(DATE_FORMAT));

  const newList = [...or, ...d1, ...d2, ...d3];
  // 날짜별 정제
  const dateList = days.reduce((acc, cur) => {
    acc[cur] = newList.filter((item) => {
      const {
        type,
        regular_payment_info,
        payment_date,
        rental_payment_info,
        payment_completion_date,
      } = item;

      let day = 0;
      if (payment_completion_date) {
        day = payment_completion_date;
      } else if (type === 'DELIVERY' || type === 'STORE_PICKUP') {
        day = payment_date;
      } else if (type === 'SUBSCRIPTION') {
        day = regular_payment_info?.payment_date;
      } else {
        day = rental_payment_info?.payment_date;
      }

      const formatDate = dayjs.unix(day).format(DATE_FORMAT);

      return formatDate === cur;
    });

    return acc;
  }, {});

  // 합산
  const summaryData = getSummarySales(dateList);

  return summaryData;
}
